/* @flow */

import {unexpectedCase} from 'nutshell-core/reducer-utils';
import {REHYDRATE} from 'redux-persist';
import {ActionTypes, type AnalyticsModalAction} from './analytics-modal-actions';

export type AnalyticsModalState = {
    isOpen: boolean,
};

export const defaultAnalyticsModalState = {
    isOpen: false,
};

export const analyticsModalReducer = (
    state: AnalyticsModalState = defaultAnalyticsModalState,
    action: AnalyticsModalAction
): AnalyticsModalState => {
    switch (action.type) {
        case ActionTypes.ANALYTICS_MODAL_OPENED:
            return {
                ...state,
                isOpen: true,
            };
        case ActionTypes.ANALYTICS_MODAL_CLOSED:
            return defaultAnalyticsModalState;
        case REHYDRATE: {
            return state;
        }
        default:
            unexpectedCase(action.type);

            return state;
    }
};
